import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { getCatalogUrl } from '../constants';
import { mediaApi } from '../services/media.service';

const prevodnaTabulka = {
    //speci znaky
    '.': '_', ',': '_', ':': '_', '?': '_', '%': '_', ' ': '_'
};

const strtr = (str: any, map: any) => {
    let result = str;
    for (const [from, to] of Object.entries(map)) {
        result = result.split(from).join(to);
    }
    return result;
}

export const handleDownloadClick = async (key: string, name: string, isCatalogDownload?: boolean, type?: string) => {
    if (isCatalogDownload) {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.href = getCatalogUrl();
        link.download = name;
        link.dispatchEvent(new MouseEvent('click'));
        return;
    }

    if (key) {
        try {
            const attData = await mediaApi.getAttachment(key);
            saveAs(attData.data, `${name}${getFileSuffixByMimeType(attData.data?.type)}`);
        } catch { }
    }

};

export const handleDownloadClickAsZip = async (materials: { _key: string; name: string; mime_type: string }[], eventSlug: string) => {
    const zip = new JSZip();

    try {
        await Promise.all(
            materials.map(async (material) => {
                const attData = await mediaApi.getAttachment(material._key);
                const name = `${material.name.replace(":", " -")}${getFileSuffixByMimeType(material.mime_type)}`;
                zip.file(name, attData.data);
            })
        );

        const blob = await zip.generateAsync({ type: 'blob' });
        saveAs(blob, `${eventSlug}.zip`);
    } catch (err) {
        console.log(err);
    }
};

const getFileSuffixByMimeType = (mimeType: string) => {
    switch (mimeType) {
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return '.docx';
        case 'application/msword':
            return '.doc';
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return '.xlsx';
        case 'application/vnd.ms-excel':
            return '.xls';
        case 'application/pdf':
            return '.pdf';
        case 'image/jpeg':
            return '.jpeg';
        case 'image/png':
            return '.png';
        case 'text/plain':
            return '.txt';
        default:
            return '';
    }
};
